import Vue from 'vue'
import Router from 'vue-router'

// views
import Home from '@/views/Home.vue'
import Ideenparty from '@/views/Ideenparty.vue'
import Podcast from '@/views/Podcast.vue'
import Impressum from '@/views/Impressum.vue'
import Disclaimer from '@/views/Disclaimer.vue'
import Datenschutz from '@/views/Datenschutz.vue'
import NotFound from '@/views/NotFound.vue'
import Aktuelles from '@/views/Aktuelles.vue'
import Plan2019 from '@/views/Plan2019.vue'

// views -> awareness
import AHome from '@/views/awareness/Start.vue'
import Karten from '@/views/awareness/Karten.vue'
import Übungen from '@/views/awareness/Übungen.vue'
import Achtsamkeit from '@/views/awareness/Achtsamkeit.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/podcast',
      name: 'podcast',
      component: Podcast
    },
    { path: '/aktuelles',
      name: 'aktuelles',
      component: Aktuelles
    },
    { path: '/events/ideenparty',
      name: 'ideenparty',
      component: Ideenparty
    },
    { path: '/plan-2019',
      name: 'plan2019',
      component: Plan2019
    },
    { path: '/achtsamkeit',
      component: Achtsamkeit,
      children:[
      {
        path: 'karten',
        name: 'achtsamkeitskarten',
        component: Karten
      },
      { 
        path: 'übungen',
        name: 'übungen',
        component: Übungen
      },
      { 
        path: '',
        name: 'ahome',
        component: AHome
      }
      ]
    },
    { path: '/impressum',
      name: 'impressum',
      component: Impressum
    },
    { path: '/disclaimer',
      name: 'disclaimer',
      component: Disclaimer
    },
    { path: '/datenschutz',
      name: 'datenschutz',
      component: Datenschutz
    },
    { path: '/',
      name: 'home',
      component: Home
    },
    { path: '*',
      name: 'notFound',
      component: NotFound
    }
  ]
})
